import React from 'react';
import { motion } from 'framer-motion';
const brands = ['Land Rover', 'Jaguar', 'Mercedes-Benz', 'BMW', 'Porsche', 'Audi', 'Ferrari', 'Lamborghini', 'Volvo'];
export function BrandsStrip() {
  return <section id="brands" className="py-12 bg-black border-y border-white/10 overflow-hidden" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <p className="text-center text-gray-500 text-sm uppercase tracking-widest mb-8 font-semibold" data-id="element-12">
          Specializing in Premium Makes
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8 opacity-70" data-id="element-13">
          {brands.map((brand, index) => <motion.span key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="text-xl md:text-2xl font-bold text-gray-400 hover:text-white transition-colors cursor-default font-serif italic" data-id="element-14">
              {brand}
            </motion.span>)}
        </div>
      </div>
    </section>;
}